var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-10,-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.324305,0,0,0.324305,-59.3712,-23.2916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.252,151.991C411.252,124.762 389.145,102.655 361.916,102.655L263.243,102.655C236.014,102.655 213.907,124.762 213.907,151.991L213.907,250.664C213.907,277.893 236.014,300 263.243,300L361.916,300C389.145,300 411.252,277.893 411.252,250.664L411.252,151.991Z",
    style: {
      fill: "rgb(47,158,201)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.295185,0,0,0.388483,-49.0779,-39.7325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.156,198.29C388.156,171.581 352.484,149.897 308.545,149.897C264.606,149.897 228.934,171.581 228.934,198.29C228.934,214.074 241.597,228.867 262.863,237.924L252.817,270.881L287.917,245.031C294.645,246.128 301.58,246.684 308.545,246.684C352.484,246.684 388.156,225 388.156,198.29Z",
    style: {
      fill: "rgb(242,242,242)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04444,0,0,1.04444,1.11111,0.222222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attatchment"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.c13318723afb46f3c4320151e5203192.svg";
export { ForwardRef as ReactComponent };